
// Vue
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, State } from 'vuex-class';

// Utils
import { get } from "lodash";

// Components
import ManualAction from "@/components/manual-actions/ManualAction.vue";

// Types
import { UserPermissions, RootState, FeaturesList } from '@/store/types';

@Component({
	components: {
		"manual-action": ManualAction,
	}
})
export default class QuickControl extends Vue {
        // -- Vuex -- //

        @Prop({ type: Boolean, default: false }) isPlugin: boolean;
        @Prop({ type: Boolean, default: false }) canUserInteractWithPlugin: boolean;

        // Root
        @State((State: RootState) => State.User.userPermissions) userPermissions: UserPermissions;
        @State((state: RootState) => state.featuresList) featureList!: FeaturesList;

        // -- Computed Properies -- //
    	private get isQuickControlEnabled(): boolean {
            if (!get(this.featureList, ["Alarms", "QuickControl"])) {
                return false;
            }

            if (!this.isPlugin) {
                return this.userPermissions.canAccessQuickControl;
            }

            return true;
		}
}
